export const BLACKBAUD_CLIENT_ID = '1d27e979-36b4-4f8e-be7b-ec2b74ee97de';

export const CAMPAIGN_MIN_BUDGET = 20;
export const CAMPAIGN_DEFAULT_MAX_BUDGET = 10000;
export const CAMPAIGN_MAX_BUDGET = 20000;
export const CAMPAIGN_MAX_BUDGET_INTERNAL = 25;
export const TRIGGERED_EMAIL_DEFAULT_DELAY = 1800;
